/*
 * File: SupportContent.styles.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on February 7, 2022 at 1:53 PM
 * Copyright © 2022 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: May 14, 2025 at 4:07 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import styled from 'styled-components';


/**
 * Styles
 */

export const MantraWrapper = styled.div`
	padding: 60px 22px 60px 22px;
`;

export const ImageWrapper = styled.div``;

export const VideoWrapper = styled.div``;

export const Video = styled.video`
	width: 100%;
    height: auto;
    border-radius: 20px;
`;

export const Image = styled.img`
	width: 100%;
    height: auto;
    border-radius: 20px;
`;

export const AttributionSection = styled.div`
	div:first-child {
		margin: 15px 0px 0px;
	}
	p {
		color: ${({ theme }) => theme.secondaryText};
	}
`;

export const AttributionLabel = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;

	p {
		color: ${({ theme }) => theme.secondaryText};
	}
	svg {
		color: ${({ theme }) => theme.secondaryText};
		font-size: 0.7rem;
		margin-left: 4px;
	}
`;
